export class StickyNavsHandler {
    items: Array<HTMLElement>;

    constructor(items: Array<HTMLElement>) {
        this.items = items;
        this.setHeightProperties();
    }

    setHeightProperties(height?: number) {
        document.body.style.setProperty('margin-top', `${height || this.activeHeight}px`);
    }

    addHeaderClass(className: string) {
        this.items.forEach(item => {
            if (!item.classList.contains(className)) {
                item.classList.add(className);
            }
        });
    }

    removeHeaderClass(className: string) {
        this.items.forEach(item => {
            if (item.classList.contains(className)) {
                item.classList.remove(className);
            }
        });
    }

    get activeHeight() {
        let activeHeight = 0;

        this.items.forEach(item => {
            activeHeight = Math.max(activeHeight, item.offsetHeight);
        });

        return activeHeight;
    }
}